module.exports = __webpack_public_path__ + "img/exchange.aab5950d.svg";